module.exports = __webpack_public_path__ + "media/munches/little-nibbler-5223b11d.svg";